import { React, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import Header from '../containers/header'
import { Form } from '../components'
import { FirebaseContext } from '../context/firebase'
import * as ROUTES from '../constants/routes'

export default function Signin() {
  const history = useHistory()
  const [emailAddress, setEmailAddress] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { firebase } = useContext(FirebaseContext)
  const isInvalid = password === '' || emailAddress === ''

  const handleSignIn = (event) => {
    event.preventDefault()
    firebase
      .auth()
      .signInWithEmailAndPassword(emailAddress, password)
      .then(() => {
        history.push(ROUTES.BROWSE)
      })
      .catch((error) => {
        setEmailAddress('')
        setPassword('')
        setError(error.message)
      })
  }
  return (
    <Header>
      <Form>
        <Form.Title>signin</Form.Title>
        {error && <Form.Error>{error}</Form.Error>}
        <Form.Base onSubmit={handleSignIn} method='POST'>
          <Form.Input
            placeholder='Email address'
            value={emailAddress}
            onChange={({ target }) => setEmailAddress(target.value)}
          />
          <Form.Input
            type='password'
            placeholder='Password'
            autoComplete='off'
            value={password}
            onChange={({ target }) => setPassword(target.value)}
          />
          <Form.Submit disabled={isInvalid} type='submit'>
            Sign In
          </Form.Submit>
        </Form.Base>
        <Form.Text>
          New to Netflix? <Form.Link to='/signup'>Signup Now</Form.Link>
        </Form.Text>
        <Form.TextSmall>
          This page is protected by google reCapture
        </Form.TextSmall>
      </Form>
    </Header>
  )
}
